export type AppPermissionType = Record<AppPermission, boolean>;

export enum AppPermission {
  UserAll = 'user.*',
  UserView = 'user.view',
  UserAdd = 'user.add',
  UserUpdate = 'user.update',
  UserRemove = 'user.remove',
  UserResetPass = 'user.resetpass',
  ClientAll = 'client.*',
  ClientView = 'client.view',
  ClientAdd = 'client.add',
  ClientUpdate = 'client.update',
  ClientRemove = 'client.remove',
  ClientResetClientSecret = 'client.resetClientSecret',
  PermissionAll = 'permission.*',
  PermissionView = 'permission.view',
  PermissionAdd = 'permission.add',
  PermissionUpdate = 'permission.update',
  PermissionRemove = 'permission.remove',
  ConfigWebAll = 'configWeb.*',
  ConfigWebUpdate = 'configWeb.update',
  ConfigWebRecruit = 'configWeb.recruit',
  CompanyAll = 'company.*',
  CompanyView = 'company.view',
  CompanyAdd = 'company.add',
  CompanyUpdate = 'company.update',
  CompanyRemove = 'company.remove',
  CompanyRemoveCompletely = 'company.removeCompletely',
  CompanyConfigFee = 'company.configFee',
  CompanyChangeAccountBalance = 'company.changeAccountBalance',
  CompanyLock = 'company.lock',
  CompanyUnlock = 'company.unlock',
  CompanyAccountAll = 'company_account.*',
  CompanyAccountView = 'company_account.view',
  CompanyAccountResetPassword = 'company_account.reset_password',
  CompanyAccountSetAdmin = 'company_account.set_admin',
  ZaloOaAccountAll = 'zalo_oa_account.*',
  ZaloOaAccountView = 'zalo_oa_account.view',
  ZaloOaAccountAdd = 'zalo_oa_account.add',
  ZaloOaAccountUpdate = 'zalo_oa_account.update',
  ZaloOaAccountRemove = 'zalo_oa_account.remove',
  PaymentPackageAll = 'paymentPackage.*',
  PaymentPackageView = 'paymentPackage.view',
  PaymentPackageAdd = 'paymentPackage.add',
  PaymentPackageUpdate = 'paymentPackage.update',
  PaymentPackageRemove = 'paymentPackage.remove',
  MenuPackageAll = 'menuPackage.*',
  MenuPackageView = 'menuPackage.view',
  MenuPackageAdd = 'menuPackage.add',
  MenuPackageUpdate = 'menuPackage.update',
  MenuPackageRemove = 'menuPackage.remove',
  CustomerAll = 'customer.*',
  CustomerView = 'customer.view',
  CustomerAdd = 'customer.add',
  CustomerUpdate = 'customer.update',
  CustomerRemove = 'customer.remove',
  CustomerStatusAll = 'customerStatus.*',
  CustomerStatusView = 'customerStatus.view',
  CustomerStatusAdd = 'customerStatus.add',
  CustomerStatusUpdate = 'customerStatus.update',
  CustomerStatusRemove = 'customerStatus.remove',
  CustomerLeadAll = 'customerLead.*',
  CustomerLeadView = 'customerLead.view',
  CustomerLeadAdd = 'customerLead.add',
  CustomerLeadUpdate = 'customerLead.update',
  CustomerLeadRemove = 'customerLead.remove',
  ReportAll = 'report.*',
  ReportCompanyRevenue = 'report.company_revenue',
  ReportCompanyChargeWallet = 'report.company_charge_wallet',
  CompanyPaymentTransactionAll = 'company_payment_transaction.*',
  CompanyPaymentTransactionView = 'company_payment_transaction.view',
  CompanyPaymentTransactionCreate = 'company_payment_transaction.create',
  MBQRPaymentAll = 'mbqr_payment.*',
  MBQRPaymentDashboard = 'mbqr_payment.dashboard',
  MBQRPaymentReport = 'mbqr_payment.report',
  MBQRPaymentExport = 'mbqr_payment.export',
  MBQRPaymentCallbackTrigger = 'mbqr_payment.callback_trigger',
  MBQRTerminalAll = 'mbqr_terminal.*',
  MBQRTerminalView = 'mbqr_terminal.view',
  MBQRTerminalRegister = 'mbqr_terminal.register',
  MBQRTerminalUpdate = 'mbqr_terminal.update',
  MBQRTerminalConfirm = 'mbqr_terminal.confirm',
  MBQRTerminalRemove = 'mbqr_terminal.remove',
  MBQRRefundAll = 'mbqr_refund.*',
  MBQRRefundView = 'mbqr_refund.view',
  MBQRRefundRequest = 'mbqr_refund.request',
  MBQRRefundCancel = 'mbqr_refund.cancel',
  DashboardAll = 'dashboard.*',
  DashboardYearlyReport = 'dashboard.yearly-report',
  DashboardCompanyYearlyReport = 'dashboard.company-yearly-report',
  DashboardAnalytics = 'dashboard.analytics',
  DashboardMonitor = 'dashboard.monitor',
  DashboardTickets = 'dashboard.tickets',
  DashboardGoods = 'dashboard.goods',
  BrandnameAll = 'brandname.*',
  BrandnameView = 'brandname.view',
  BrandnameAdd = 'brandname.add',
  BrandnameUpdate = 'brandname.update',
  BrandnameRemove = 'brandname.remove',
  SystemAll = 'system.*',
  SystemRestartService = 'system.restart_service',
  SystemBannerManagement = 'system.banner_management',
  BalanceFluctuationMissingAll = 'balance_fluctuation_missing.*',
  BalanceFluctuationMissingView = 'balance_fluctuation_missing.view',
  BalanceFluctuationMissingCheck = 'balance_fluctuation_missing.check',
  BIDVQRPaymentAll = 'bidvqr_payment.*',
  BIDVQRPaymentDashboard = 'bidvqr_payment.dashboard',
  BIDVQRPaymentReport = 'bidvqr_payment.report',
  BIDVQRPaymentExport = 'bidvqr_payment.export',
  BIDVQRPaymentCallbackTrigger = 'bidvqr_payment.callback_trigger',
  BIDVQRTerminalAll = 'bidvqr_terminal.*',
  BIDVQRTerminalView = 'bidvqr_terminal.view',
  BIDVQRTerminalUpdate = 'bidvqr_terminal.update',
  BIDVQRTerminalConfirm = 'bidvqr_terminal.confirm',
  BIDVQRTerminalRemove = 'bidvqr_terminal.remove',
  BIDVQRTerminalRegister = 'bidvqr_terminal.register',
  BIDVQRRefundAll = 'bidvqr_refund.*',
  BIDVQRRefundView = 'bidvqr_refund.view',
  BIDVQRRefundRequest = 'bidvqr_refund.request',
  BIDVQRRefundCancel = 'bidvqr_refund.cancel',
  DataSyncAll = 'data_sync.*',
  DataSyncView = 'data_sync.view',
  DataSyncCheck = 'data_sync.check',
  BalanceFluctuationAll = 'balance_fluctuation.*',
  BalanceFluctuationView = 'balance_fluctuation.view',
  BalanceFluctuationRefund = 'balance_fluctuation.refund',
  BalanceFluctuationRunPayFee = 'balance_fluctuation.run_pay_fee',
  CloudSpeakerAll = 'cloud_speaker.*',
  CloudSpeakerView = 'cloud_speaker.view',
  CloudSpeakerAdd = 'cloud_speaker.add',
  CloudSpeakerUpdate = 'cloud_speaker.update',
  CloudSpeakerRemove = 'cloud_speaker.remove',
  PartnerAll = 'partner.*',
  PartnerView = 'partner.view',
  PartnerAdd = 'partner.add',
  PartnerUpdate = 'partner.update',
  PartnerRemove = 'partner.remove',
  SystemBannerAll = 'system_banner.*',
  SystemBannerView = 'system_banner.view',
  SystemBannerAdd = 'system_banner.add',
  SystemBannerUpdate = 'system_banner.update',
  SystemBannerRemove = 'system_banner.remove',
  InvoiceConfig = 'invoice_config.*',
  InvoiceConfigView = 'invoice_config.view',
  InvoiceConfigCreate = 'invoice_config.create',
  InvoiceConfigUpdate = 'invoice_config.update',
  InvoiceConfigRemove = 'invoice_config.remove',
  NapasQRPaymentAll = 'napas_qr_payment.*',
  NapasQRPaymentDashboard = 'napas_qr_payment.dashboard',
  NapasQRPaymentReport = 'napas_qr_payment.report',
  NapasQRPaymentExport = 'napas_qr_payment.export',
  NapasQRPaymentCallbackTrigger = 'napas_qr_payment.callback_trigger',
  NapasQRTerminalAll = 'napas_qr_terminal.*',
  NapasQRTerminalView = 'napas_qr_terminal.view',
  NapasQRTerminalUpdate = 'napas_qr_terminal.update',
  NapasQRTerminalConfirm = 'napas_qr_terminal.confirm',
  NapasQRTerminalRemove = 'napas_qr_terminal.remove',
  NapasQRRefundAll = 'napas_qr_refund.*',
  NapasQRRefundView = 'napas_qr_refund.view',
  NapasQRRefundRequest = 'napas_qr_refund.request',
  NapasQRRefundCancel = 'napas_qr_refund.cancel',
  LHVPartnerAll = 'lhv_partner.*',
  LHVPartnerView = 'lhv_partner.view',
  LHVPartnerReset = 'lhv_partner.reset',
  VpbQRPaymentAll = 'vpbqr_payment.*',
  VpbQRPaymentDashboard = 'vpbqr_payment.dashboard',
  VpbQRPaymentReport = 'vpbqr_payment.report',
  VpbQRPaymentExport = 'vpbqr_payment.export',
  VpbQRPaymentCallbackTrigger = 'vpbqr_payment.callback_trigger',
  VpbQRTerminalAll = 'vpbqr_terminal.*',
  VpbQRTerminalView = 'vpbqr_terminal.view',
  VpbQRTerminalUpdate = 'vpbqr_terminal.update',
  VpbQRTerminalConfirm = 'vpbqr_terminal.confirm',
  VpbQRTerminalRemove = 'vpbqr_terminal.remove',
  VpbQRTerminalRegister = 'vpbqr_terminal.register',
  VpbQRCustomerSdkLogAll = 'vpbqr_customer_sdk_log.*',
  VpbQRCustomerSdkLogView = 'vpbqr_customer_sdk_log.view',
  VpbQRCustomerSdkLogDelete = 'vpbqr_customer_sdk_log.delete',
  VpbQRCustomerSdkLogExport = 'vpbqr_customer_sdk_log.export',
  MerchantPaymentAll = 'merchant_payment.*',
  MerchantPaymentView = 'merchant_payment.view',
  MerchantPaymentAdd = 'merchant_payment.add',
  MerchantPaymentUpdate = 'merchant_payment.update',
  MerchantPaymentRemove = 'merchant_payment.remove',
  TransitWithPartnerAll = 'transit_with_partner.*',
  TransitWithPartnerView = 'transit_with_partner.view',
  TransitWithPartnerAdd = 'transit_with_partner.add',
  TransitWithPartnerUpdate = 'transit_with_partner.update',
  TransitWithPartnerUpdateAdmin = 'transit_with_partner.update_admin',
  TransitWithPartnerRemove = 'transit_with_partner.remove',
  TransitWithPartnerDashboard = 'transit_with_partner.dashboard',
  TransitWithPartnerReport = 'transit_with_partner.report',
  TransitWithPartnerExport = 'transit_with_partner.export',
  TransitWithPartnerCancelOrder = 'transit_with_partner.order_cancel',
  DynamicReportAll = 'dynamic_report.*',
  DynamicReportView = 'dynamic_report.view',
  DynamicReportAdd = 'dynamic_report.add',
  DynamicReportUpdate = 'dynamic_report.update',
  DynamicReportRemove = 'dynamic_report.remove',
  TransitAnvuiStopPointAll = 'transit_anvui_stop_point.*',
  TransitAnvuiStopPointView = 'transit_anvui_stop_point.view',
  TransitAnvuiStopPointAdd = 'transit_anvui_stop_point.add',
  TransitAnvuiStopPointUpdate = 'transit_anvui_stop_point.update',
  TransitAnvuiStopPointRemove = 'transit_anvui_stop_point.remove',
  TransitAnvuiStopPointConfigFee = 'transit_anvui_stop_point.config_fee',
  VehicleUtilitiesAll = 'vehicle_utilities.*',
  VehicleUtilitiesView = 'vehicle_utilities.view',
  VehicleUtilitiesAdd = 'vehicle_utilities.add',
  VehicleUtilitiesUpdate = 'vehicle_utilities.update',
  VehicleUtilitiesRemove = 'vehicle_utilities.remove',
  CompanyFeedbackAll = 'company_feedback.*',
  CompanyFeedbackView = 'company_feedback.view',
  CompanyFeedbackRespond = 'company_feedback.respond',
  CompanyNotificationAll = 'company_notification.*',
  CompanyNotificationView = 'company_notification.view',
  CompanyNotificationAdd = 'company_notification.add',
  CompanyNotificationUpdate = 'company_notification.update',
  CompanyNotificationRemove = 'company_notification.remove',
  CompanyPartnerAll = 'company_partner.*',
  CompanyPartnerView = 'company_partner.view',
  CompanyPartnerAdd = 'company_partner.add',
  CompanyPartnerUpdate = 'company_partner.update',
  CompanyPartnerRemove = 'company_partner.remove',
  CompanyPartnerAddStaff = 'company_partner.add_staff',
  CompanyPartnerDeposit = 'company_partner.deposit',
  TransitSurchargeRuleAll = 'transit_surcharge_rule.*',
  TransitSurchargeRuleView = 'transit_surcharge_rule.view',
  TransitSurchargeRuleAdd = 'transit_surcharge_rule.add',
  TransitSurchargeRuleUpdate = 'transit_surcharge_rule.update',
  TransitSurchargeRuleRemove = 'transit_surcharge_rule.remove',
  TransitAnvuiReportAll = 'transit_anvui_report.*',
  TransitAnvuiReportTicketView = 'transit_anvui_report.ticket_view',
  TransitAnvuiReportStaffRevenueView = 'transit_anvui_report.staff_revenue_view',
  TransitAnvuiReportCompanyRevenueView = 'transit_anvui_report.company_revenue_view',
  TransitAnvuiReportExport = 'transit_anvui_report.export',
  TransitAnvuiReportStationAll = 'transit_anvui_report_station.*',
  TransitAnvuiReportStationTicketView = 'transit_anvui_report_station.ticket_view',
  TransitAnvuiReportStationRevenueView = 'transit_anvui_report_station.revenue_view',
}
